module.exports = __webpack_public_path__ + "static/img/wallet_card_dollar.004f2f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/wallet_card_dollar.png
// module id = yFsz
// module chunks = 1